import React from "react";
import {useAppSelector} from "../../../app/hooks";
import {buttonColourSelector} from "../../chatbotSlice";
interface ConvoStarterButtonsProps {
    starter: string;
    handleConvoStarterClick: (starter: string) => void;
    extraClasses?: string;
}

export const ConvoStarterButton: React.FC<ConvoStarterButtonsProps> = ({starter, handleConvoStarterClick, extraClasses}) => {
    const buttonColor = useAppSelector(buttonColourSelector);

    return <button
        className={`py-2 px-2 text-base font-semibold border rounded-full
               transition-transform transform hover:scale-105 ${extraClasses}`}
        style={{color: buttonColor, borderColor: buttonColor}}
        onClick={() => handleConvoStarterClick(starter)}>
        {starter}
    </button>
};
